<div
    [class.fullscreen-mode]="fullscreen"
    [ngClass]="{ 'se-partial-full-screen': changeViewIfRightSidenav, 'se-fullscreen': !changeViewIfRightSidenav ||  fullscreen }"
    >
    <img
        (click)="onFullScreenToggle()"
        [hidden]="!enableFullscreenMode"
        [src]="fullscreen ? 'assets/images/ZoomOut.png' : 'assets/images/ZoomIn.png'"
        alt="Toggle fullscreen"
        class="se-image-fullscreen"
    />
    <ng-content></ng-content>
</div>
